module.exports = __webpack_public_path__ + "static/logo-white-text-4bfb5e475b1846a73ff69a6ad906739d.png";